import { Container } from 'components/shared';
// import { hideScrollbar, CustomImage as Image } from '../..';
import styles from './index.module.css';
// import { SkinTemperatureModal } from './SkinTemperatureModal';
import { DesktopRecoveryComponent } from './DesktopRecoveryComponent';
import { MobileRecoveryComponent } from './MobileRecoveryComponent';

export const BentoSection = ({ className }: { className?: string }) => {
  return (
    <section className={className ? `${styles.root} ${className}` : styles.root}>
      <Container>
        {/* both branches render; CSS picks one at 993px (useWindowSize is 0 on SSR) */}
        <DesktopRecoveryComponent className={styles.bentoDesktop} />
        <MobileRecoveryComponent className={styles.bentoMobile} />
      </Container>

      {/* <MagicModal /> */}
    </section>
  );
};
